import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import _ from 'lodash'
import Carousel from 'nuka-carousel';
import ReactGA from 'react-ga4';

const CarouselContainer = styled.div`
  .slider-control-centerleft {
    display: none;
  }
  .slider-control-bottomcenter {
    display: none;
  }
  .slider-control-centerright {
    position: absolute;
    right: 20px;
    top: 15px;
    background-color: #A5A5A5;
    border-radius: 10px;
  }
  
  /* 모든 슬라이더에 적용 - 수직 스크롤 방지 */
  .slider-list {
    touch-action: pan-x;
    user-select: none;
    -webkit-user-drag: none;
  }
  
  /* 배너가 하나일 때 드래그 비활성화 추가 설정 */
  ${props => props.isSingleBanner && `
    .slider-list {
      transform: none !important;
    }
  `}
`;

const CountContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 20px;
  padding: 3px 5px;
  font-size: 8px;
  overflow: hidden;
`;

let setAutoplayTime;

function DefaultCarousel({ children = [], bannerSize, gaPage }) {
  const flattenChildren = _.flatten(children);
  
  const [autoplayStatus, setAutoplayStatus] = useState(true);
  const [currentCount, setCurrentCount] = useState(1);
  const [slideCount, setSlideCount] = useState(0);

  const [language, setLanguage] = useState('kor'); // kor / eng / chi
  
  const getParameter = () => {
    // const accessToken = new URLSearchParams(window.location.search).get('accessToken');
    // console.log('accessToken : ', accessToken)
    // const appVersion = new URLSearchParams(window.location.search).get('appVersion');
    // console.log('appVersion : ', appVersion)
    // const os = new URLSearchParams(window.location.search).get('os');
    // console.log('os : ', os)
    // const isDarkMode = new URLSearchParams(window.location.search).get('isDarkMode');
    // console.log('isDarkMode : ', isDarkMode)
    const language = new URLSearchParams(window.location.search).get('language');
    // console.log('language : ', language)
    setLanguage(language || 'kor')
  };

  useEffect(() => {
    const path = window.location.pathname

    if(path === '/popup-square'){
      // popup_square
      ReactGA.initialize('G-8TQTJTKXWM')
    } else if (path === '/horizontal-bar') {
      // horizontal_bar
      ReactGA.initialize('G-FGGZKG0QQY')
    } else {
      // main_card
      ReactGA.initialize('G-P4KR2H7LX4')
    }

    // 페이지 초기화 GA Event
    ReactGA.event(`Page Opened_${gaPage}`);
    // 첫 페이지 카운팅
    ReactGA.event(`Page Shown_${gaPage}_${flattenChildren[0].props.name}`);
  }, [])

  useEffect(() => {
    getParameter()
    setSlideCount(flattenChildren.length || 1)
  }, [flattenChildren.length])

  const onChangeCurrentCount = ( i ) => {
    setCurrentCount(i+1)
    
    // 페이지 스크롤 GA Event
    ReactGA.event(`Page Shown_${gaPage}_${flattenChildren[i].props.name}`);
  };

  const renderCenterRightControls = ({ nextDisabled, nextSlide }) => (
    <CountContainer>
      <div>{currentCount}</div>
      <div>/</div>
      <div>{slideCount}</div>
    </CountContainer>
  );

  const onTouchStart = () => {
    clearTimeout(setAutoplayTime)
    setAutoplayStatus(false)
  };

  const onTouchEnd = () => {
    setAutoplayTime = setTimeout(() => {
      setAutoplayStatus(true)
    }, 2000)
  };

  const childrenWithLanguage = flattenChildren.map(child => React.cloneElement(child, { language }));

  return (
    <CarouselContainer bannerSize={bannerSize} isSingleBanner={flattenChildren.length === 1}>
      <Carousel
        wrapAround={flattenChildren.length > 1}
        autoplay={flattenChildren.length > 1 && autoplayStatus}
        dragging={flattenChildren.length > 1}
        autoplayInterval={3000}
        onDragStart={() => onTouchStart()}
        onDragEnd={() => onTouchEnd()}
        dragThreshold={0.25}
        afterSlide={(i) => onChangeCurrentCount(i)}
        renderCenterRightControls={bannerSize === 'horizontal-bar' || slideCount < 2 ? null : renderCenterRightControls}
        // children={flattenChildren}
        children={childrenWithLanguage}
        pauseOnHover={false}
        preventMovementUntilSwipeScrollTolerance={true}
        swipeScrollTolerance={50}
        enableKeyboardControls={false}
      />
    </CarouselContainer>
  )
}

export default DefaultCarousel;
